import { Component, Inject } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-login',
    template: '',
    standalone: false
})
export class LoginComponent {

  constructor(private router:Router) {}

   ngOnInit() {
    this.router.navigate(['']);
  }
}
